module.exports = __webpack_public_path__ + "static/media/engagePeoLogo.e2d7dcce.jpg";